import type {Prize} from 'services/prizes/types';
import type {GetTokens} from './types';
import type {Schemas} from './dto.generated';
import {exceptionToPromiseReject} from './exceptionToPromiseReject';
import {httpGet} from './http/ebba';
import {mapPrizeSearchDto} from './mappers';
import type {SearchResult} from './searchTypes';

export const searchPrize = (
  query: string,
  page: number,
  size: number,
  getTokens: GetTokens,
  _?: AbortSignal,
): Promise<SearchResult<Prize>> => {
  const emptySearch = query.trim() === '' || query.trim() === '*';
  return exceptionToPromiseReject(() =>
    httpGet<Schemas.LiteraturePrizesPageResponse, SearchResult<Prize>>({
      subdir: 'literatureprize/search',
      queryParams: {
        name: emptySearch ? '' : query,
        page,
        size,
        sort: emptySearch ? 'name' : undefined,
      },
      getTokens,
    }).then(dto => mapPrizeSearchDto(query, dto)),
  );
};
